/**
 * Created by eritru on 2015-09-14.
 * Fonction javascrpt temporaire � d�placer dans le init et save du wizard une fois finalis�
 */

function init_certificat() {
    $('.redressement-donnees').on('click', function(e){
        var valeurCourante = $(e.target).closest('tr').find('.redressement-donnees').is(':checked');
        if(valeurCourante){
            $(e.target).closest('tr').find('.emettre-certificat').prop('checked', false);
            $(e.target).closest('tr').find('.correction-sans-frais').prop('checked', false);
            $(e.target).closest('tr').find('.correction-sans-frais').prop('disabled', true);
        }
    });

    $('.emettre-certificat').on('click', function(e){
        var valeurCourante = $(e.target).closest('tr').find('.emettre-certificat').is(':checked');
        if(valeurCourante){
            $(e.target).closest('tr').find('.redressement-donnees').prop('checked', false);
            $(e.target).closest('tr').find('.correction-sans-frais').prop('disabled', false);
        } else {
            $(e.target).closest('tr').find('.correction-sans-frais').prop('checked', false);
            $(e.target).closest('tr').find('.correction-sans-frais').prop('disabled', true);
        }
    });

    $('.correction-sans-frais').on('click', function(e){
        var valeurCourante = $(e.target).closest('tr').find('.correction-sans-frais').is(':checked');
        var idCertificat = $(e.target).closest('tr').find('.id-certificat').attr('datavalue');
        if(valeurCourante){
            $('#remarque-certificat-'+idCertificat).show();
        } else {
            $('#remarque-certificat-'+idCertificat).hide();
        }
    });

    $(".liste-motif-certificat, .liste-motif-certificat-exclu").select2({
        dropdownAutoWidth: true,
        placeholder: "Choisir un motif"
    });

    //ajoute des motif suppl à la section Raison(s) de la modifications
    $(".liste-motif-certificat, .liste-motif-certificat-exclu").on("change", function (e) {
        chargerRemarque();
    });

    //supprime des motif suppl à la section Raison(s) de la modifications
    $(".liste-motif-certificat, .liste-motif-certificat-exclu").on("select2-removed", function (e) {
        chargerRemarque();
    });

    // ajoute un remarque dynamiquement dans la section remarque
    $(".remarque-certificat").keyup(function () {
        chargerRemarqueManuelle();
    });

    // Ajoute les motifs dynamiquement dans la section motif
    $('#table-evenements-eec').on('change', 'input[type="checkbox"]', function () {
        $('#certificat-toggle').attr('modifie', 'True');

        // TODO : à remettre quand on va gérer plusieurs évènements dans un seul certificat
        // chargerRemarque();
    });

    $('#table-certificat-eec').on('change', 'input[type="checkbox"]', function () {
        $('#certificat-toggle').attr('modifie', 'True');

        // TODO : à remettre quand on va gérer plusieurs évènements dans un seul certificat
        // chargerRemarque();
    });

    var emettreCertificat = $('#contenu .emettre-certificat:checkbox');
    var boolCertificat = emettreCertificat.attr('bool-certificat');
    var batimentAvecModif = emettreCertificat.attr('batiment-avec-modif');
    var propagationMemeJour = emettreCertificat.attr('propagation-meme-jour');
    var tvd10 = emettreCertificat.attr('tvd-10');
    var permisSansChangementValeur = emettreCertificat.attr('permis-sans-changement-valeur');
    var propagationSansModification = emettreCertificat.attr('propagation-sans-modification');
    // la case 'Émettre certificat' est :
    // - coché et désactivé par défaut s'il y a des modifications
    // - décoché et désactivé par défaut s'il y a aucune modification
    // - coché/décoché et activé quand il y a un changement précis dans le bâtiment
    // - coché/décoché et activé quand il y a plusieurs propagations la même journée sauf la dernière propagation
    // - coché/décoché et activé quand le permis n'a pas de changement de valeur, on veut le facturer quand même
    // - coché et désactivé par défaut si c'est une propagation sans modification et qu'il y a un certificat émis la
    //   même journée et que l'évènement par dessus lequel on propage n'est pas un nouveau rôle
    if (tvd10 === 'True') {
        emettreCertificat.prop('checked', false);
        emettreCertificat.prop('disabled', true);
    }
    else {
        if (batimentAvecModif === 'True' || propagationMemeJour === 'True') {
            emettreCertificat.prop('checked', boolCertificat == 'None' ? true : boolCertificat == 'True');
            emettreCertificat.prop('disabled', false);
        }

        if(permisSansChangementValeur === 'True') {
            emettreCertificat.prop('disabled', false);
        }

        if (propagationSansModification === 'True') {
            emettreCertificat.prop('checked', true);
            emettreCertificat.prop('disabled', true);
        }
    }

    // activer le bouton 'Sauvegarder' et notifier le changement quand la case 'Émettre certificat' a changé
    // depuis le chargement ou depuis la dernière sauvegarde
    var idCertificat = $('#contenu .id-certificat').attr('datavalue');
    var estModifie =
        (boolCertificat === 'False' && emettreCertificat.prop('checked')) ||
        (boolCertificat === 'True' && !emettreCertificat.prop('checked')) ||
        (boolCertificat === 'True' && idCertificat === 'None');

    if (estModifie) {
        $('#btn-wizard-save').prop('disabled', false);
        $('#certificat-toggle').attr('modifie', 'True');
    }

    //if (!$("#collapse-evenement-accordeon").hasClass('collapsed'))  $('#collapse-evenement-accordeon').trigger('click');

    var idEvenement = '';
    $('#table-certificat-eec tr').each(function () {
        if ($(this).data('id_evenement')) {
            idEvenement = $(this).data('id_evenement');
            //$(this).closest('tr').addClass('certificat-actif');
            //$(this).closest('tr').find('input:checkbox').removeAttr('disabled');
        }
    });

    // je ne sais pas si ça sert vraiment
    $("#id-evenement").text('(' + $('#wizard').attr('id-evenement') + ')');
    tenueAJourModal.ajusterHauteurTdComparees(['identification'], ['avant', 'apres']); // On ajuste la hauteur des éléments comparés dans des TD différents
    tenueAJourModal.ajusterHauteurTdComparees(['repartition-fiscale'], ['avant', 'apres']); // On ajuste la hauteur des éléments comparés dans des TD différents

    // detailCertificat($('#wizard').attr('id-evenement'));

    // Bouton voir certificat
    //$('.btn-voir-vertificat').on('click', function (a) {
    //
    //    // on enable seulement le checkbox et on met en couleur la ligne du tableau active
    //    $('#table-certificat-eec tr').each(function () {
    //        $(this).removeClass('certificat-actif');
    //        $(this).find('input:checkbox').attr('disabled', '');
    //    });
    //
    //    $(a.target).closest('tr').addClass('certificat-actif');
    //
    //    // si l'evenement est ferme, on permet seulement la visualisation
    //    var statut = $(a.target).closest('tr').data('ferme');
    //    if (statut != '99') {
    //        $(a.target).closest('tr').find('input:checkbox').removeAttr('disabled');
    //    }
    //
    //    var idEvenement = $(a.target).closest('tr').data('id_evenement');
    //    var list_motif = $(a.target).closest('tr').find(".liste-motif-certificat").select2('data');
    //    var remarque = $(a.target).closest('tr').find(".remarque-certificat").val();
    //
    //    detailCertificat(idEvenement, list_motif, remarque);
    //
    //
    //});

    //$(".emettre-certificat").click(function (a) {
    //    // on enable remarque et commentaire si checkbox s�lectionn�
    //    $('#table-certificat-eec tr').each(function () {
    //        $(this).find('input:text').attr('disabled', '');
    //        $(this).find('select').attr('disabled', '');
    //    });
    //
    //    if ($(a.target).is(':checked')) {
    //        $(a.target).closest('tr').find('input:text').removeAttr('disabled');
    //        $(a.target).closest('tr').find('select').removeAttr('disabled');
    //
    //        //$(a.target).closest('tr').find('data-checkbox').val('1');
    //    }
    //
    //});

    //// bouton save qui va aller �ventuellement dans le wizard
    //$('#save-certificat').on('click', function () {
    //
    //    //console.log('Save');
    //    // cr�ation d'un json � partir d'un tableau
    //    var list_certificat = tableToJson('table-certificat-eec');
    //    var list_evenement = tableToJson('table-evenements-eec');
    //
    //    //console.log(list_certificat);
    //    //console.log(list_evenement);
    //
    //    params = {
    //        'list_certificat': list_certificat,
    //        'list_evenement': list_evenement
    //    };
    //
    //    var idUe =  $('#save-certificat').data('id_ue');
    //
    //    $.ajax({
    //        type: "POST",
    //        url: '/gestion-roles/save-certificat/' + idUe + '/',
    //        dataType: 'json',
    //        data: params,
    //        success: function (response) {
    //
    //            var certificat_jon = response;
    //            //console.log(certificat_json);
    //
    //            // on remet la valeur id_certificat � l'attribut dataValue afin de r�fl�ter la bd apr�s la sauvegarde
    //
    //            i = 0;
    //            $('#table-certificat-eec tbody tr').each(function () {
    //                $(this).find('.id-certificat').attr( 'dataValue', certificat_json[i] );
    //                i++;
    //            });
    //
    //            $('#table-evenements-eec tbody tr').each(function () {
    //                $(this).find('.id-certificat').attr( 'dataValue', certificat_json[i] );
    //                i++;
    //            });
    //
    //        }
    //    });
    //
    //});

    // on suit le comportament d'emettre certificat
    if($('.emettre-certificat').is(':checked')){
        var disableRedressementDonnees = $('.emettre-certificat').prop('disabled');
        if ($('.redressement-donnees').is(':checked')) {
            disableRedressementDonnees = false;
        }
        $('.redressement-donnees').prop('disabled', disableRedressementDonnees);
        $('.correction-sans-frais').prop('disabled', false);
    }
}

function tableToJson(table) {

    // 2 premisse de base
    //Il faut mettre l'attribut data-name="" dans les th du tableau
    //Il faut mettre l'attribut data-value="" dans le td du tableau

    var columns = $('#' + table + ' thead th').map(function () {
        return $.trim($(this).data('name'));
        //return  $.trim($(this).text());
    });

    var tableObject = $('#' + table + ' tbody tr').map(function (i) {
        var row = {};
        $(this).find('td').each(function (i) {
            var rowName = columns[i];

            //On recupere la valeur de l'attribut' dataValue en fonction du type de control

            if ($(this).attr('dataValue') == 'input:text') {
                row[rowName] = $(this).find("input").val();
            }
            if ($(this).attr('dataValue') == 'input:checkbox') {
                row[rowName] = $(this).find("input").is(':checked');
            }

            //select2 multiple
            if ($(this).attr('dataValue') == 'select') {

                var list_motif = $(this).find(".liste-motif-certificat, .liste-motif-certificat-exclu").select2('data');
                var motif_selected = [];
                $.each(list_motif, function (index, value) {
                    motif_selected.push(value.id);
                });
                row[rowName] = motif_selected;
            }

            //tous les autres contr�les sauf input et select
            if ($(this).attr('dataValue') != 'input:checkbox' && $(this).attr('dataValue') != 'input:text' && $(this).attr('dataValue') != 'select') {
                row[rowName] = $(this).attr('dataValue');
            }


        });
        return row;
    }).get();

    return JSON.stringify(tableObject);
}


function detailCertificat(idEvenement, list_motif, remarque) {

    $.ajax({
        type: "GET",
        url: '/gestion-roles/detail-certificat/evenement/' + idEvenement + '/',
        dataType: 'html',
        success: function (response) {

            $("#panel-body-certificat").html('');
            $("#panel-body-certificat").append(response);


            fenetreModal.calculerHauteurModal($('#modal-wizard-evenement'));

            $("#id-evenement").text('(' + idEvenement + ')');

            // si plus 10 lots et/ou plus 3 proprietaire
            tenueAJourModal.ajusterHauteurTdComparees(['identification'], ['avant', 'apres']); // On ajuste la hauteur des éléments comparés dans des TD différents
            //on recharge le commentaire et les motifs
            //$.each(list_motif, function (index, value) {
            //    $("#motif-certificat ul").append('<li id="' + value.id + '-motif">' + value.text + '</li>');
            //});

            //on recharge la remarque
            //$("#remarque-certificat").val(remarque);
        }
    });
}

function chargerRemarque() {
    var listeRaison = [];
    var raisonStr = '';

    $('#certificat-toggle').attr('modifie', 'True');

    if ($('.emettre-certificat').is(':checked')) {
        var permis = '';
        $('#table-certificat-eec tr, #table-evenements-eec tr').each(function () {
            var checkbox = $(this).find('input[type=checkbox]');
            if (checkbox.is(':checked')) {
                if (permis != '') {
                    permis += ';';
                }
                var noPermis = $(this).attr('no-permis');
                if (noPermis != 'None') {
                    permis += noPermis;
                }

                var raison = checkbox.attr('data-motif');
                var raisonSplit = raison.split('/');
                $.each(raisonSplit, function (idx, valeur) {
                    if (valeur && $.inArray(valeur, listeRaison) == -1) {
                        listeRaison.push(valeur);
                    }
                });
            }
        });

        var arrMotif = $(".liste-motif-certificat").select2('data');
        $.each(arrMotif, function (idx, valeur) {
            var raison = valeur.text;
            if ($.inArray(raison, listeRaison) == -1) {
                listeRaison.push(raison);
            }
        });

        arrMotif = $(".liste-motif-certificat-exclu").select2('data');
        $.each(arrMotif, function (idx, valeur) {
            var raison = valeur.text;
            var idxInArray = $.inArray(raison, listeRaison);
            if (idxInArray != -1) {
                listeRaison.splice(idxInArray, 1);
            }
        });

        raisonStr = '<ul>';
        if (listeRaison.length > 0) {
            for (var i = 0; i < listeRaison.length; i++) {
                raisonStr += '<li>' + listeRaison[i] + '</li>';
            }
        }
        raisonStr += '</ul>';
    }

    $('#motif-certificat').html(raisonStr);
}

function chargerRemarqueManuelle() {
    $('#certificat-toggle').attr('modifie', 'True');

    var remarque = $('.remarque-certificat').val();
    $('.div-remarque-manuelle-certificat p').text(remarque);
}
